module.exports = "/matchcenter-staging/assets/images/matchcenter_search.c24196cb7a656525dab9e25c07005b5c.svg";